/**
 * RoadmapCommentInfoRemapper
 *
 * Parses Firestore wire JSON into a `RoadmapCommentInfoDto`.
 * Flutter source: lib/data/models/roadmap_comment_info.dart (no @JsonKey on the
 * serialized fields — Dart property == Firestore field). `highlightParentComment`
 * is a UI-only flag (`includeFromJson: false`) and is not on the wire / DTO.
 */
import type { RoadmapCommentInfoDto } from '@/data/dtos/info/roadmapCommentInfoDto';
import type { JsonObject } from '@/data/types/json';

export class RoadmapCommentInfoRemapper {
  static fromJson(data: JsonObject): RoadmapCommentInfoDto {
    return {
      id: (data['id'] as string | undefined) ?? '',
      roadmapItemId: (data['roadmapItemId'] as string | undefined) ?? '',
      replyId: data['replyId'] as string | undefined,
      parentId: data['parentId'] as string | undefined,
    };
  }

  static fromJsonList(dataList: JsonObject[]): RoadmapCommentInfoDto[] {
    return dataList.map(RoadmapCommentInfoRemapper.fromJson);
  }

  /**
   * Serialize for the notification `info.toJson()` payload.
   * Flutter `_$RoadmapCommentInfoToJson` (explicitToJson) emits `id`,
   * `roadmapItemId`, `replyId`, `parentId` — writing `replyId`/`parentId` keys
   * even when null. The UI-only `highlightParentComment` flag is `includeToJson:
   * false` and is not on the wire. Matches the `commentInfoRemapper.toJson`
   * null-vs-omit convention (emit `null`, never drop the key).
   */
  static toJson(dto: RoadmapCommentInfoDto): JsonObject {
    return {
      id: dto.id,
      roadmapItemId: dto.roadmapItemId,
      replyId: dto.replyId ?? null,
      parentId: dto.parentId ?? null,
    };
  }
}
